import React, {ReactNode} from 'react';
import './MultiLineTextOverflow.styl';

interface Props {
  lines?: number;
  content?: ReactNode;
  className: string;
}

export default class MultiLineTextOverflow extends React.PureComponent<Props> {
  static defaultProps = {
    lines: 2,
  };

  render() {
    const {className, lines, ...props} = this.props;
    return (
      <span
        // This style needs to be applied here to avoid being lost in
        // styl transpilation
        // https://github.com/postcss/autoprefixer/issues/1141
        style={{
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lines,
        }}
        {...props}
        className={`multi-line-text-overflow ${className}`}>
        {this.props.content ?? this.props.children}
      </span>
    );
  }
}
